import { useRef } from 'react';

import { CalendarPlus, Plus, UserPlus } from 'lucide-react';

import { Button } from '@nesso/ui/primitives/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@nesso/ui/primitives/dropdown-menu';

import { openScheduleSession } from '@/features/session/schedule-session';
import { useSheetStore } from '@/shared/stores/sheet-store';

type Props = {
    hasEhrAccess: boolean;
};

export function CreateMenu({ hasEhrAccess }: Props) {
    return hasEhrAccess ? <CreateMenuContent /> : null;
}

function CreateMenuContent() {
    const openSheet = useSheetStore((state) => state.openSheet);
    const isNewClientPendingRef = useRef(false);

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <Button
                    type="button"
                    variant="ghost"
                    aria-label="Create"
                    className="data-[state=open]:bg-accent/50 has-[>svg]:px-4"
                >
                    <Plus aria-hidden="true" />
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="w-36.75"
                onCloseAutoFocus={(event) => {
                    // The sheet opens once the menu is gone: an exiting item that loses the pointer
                    // focuses the menu, which would blur the sheet's First name field empty.
                    if (!isNewClientPendingRef.current) return;
                    isNewClientPendingRef.current = false;
                    event.preventDefault();
                    openSheet({ type: 'clients/add', label: 'New Client' });
                }}
            >
                <DropdownMenuItem onSelect={() => openScheduleSession()}>
                    <CalendarPlus aria-hidden="true" />
                    New session
                </DropdownMenuItem>
                <DropdownMenuItem
                    onSelect={() => {
                        isNewClientPendingRef.current = true;
                    }}
                >
                    <UserPlus aria-hidden="true" />
                    New client
                </DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
